<section class="py-6 border-b border-b-shs-gray-4" [formGroup]="itemOrQuantityInternationalForm!">
    <h2 class="text-base font-bold text-font-primary">Additional Information</h2>
    <div class="mt-4 flex flex-col gap-4">
        @switch (itemOrQuantityInternationalForm?.get('issueType')?.value) { @case
        (itemOrQuantityDiscrepancies.WRONG_BATCH_SHIPPED) {
        <sag-ui-radio-group
            label="Were the affected Lots declined within 24 hours of IDOC/Order Confirmation receipt?"
            direction="row"
            [required]="true"
        >
            <sag-ui-radio name="lotsDeclinedWithin24Hours" formControlName="lotsDeclinedWithin24Hours" [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio name="lotsDeclinedWithin24Hours" formControlName="lotsDeclinedWithin24Hours" [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>
        @if (itemOrQuantityInternationalForm?.get('lotsDeclinedWithin24Hours')?.value) {
        <app-attachments-input
            [form]="itemOrQuantityInternationalForm!"
            [required]="true"
            controlName="communicationDeclinedDocuments"
            label="Attach a copy of the communication declining the batch"
        />
        } @if (itemOrQuantityInternationalForm?.get('lotsDeclinedWithin24Hours')?.value === false) {
        <div class="rounded-md bg-shs-red grid grid-cols-[50px_auto] shadow-md items-center p-4 max-w-[950px]">
            <span class="icon-circle-error text-white text-3xl"></span>
            <span class="text-white text-sm font-bold pr-8"
                >Failure to communicate upon batch allocation. The option to request a financial adjustment (credit) is
                not available.</span
            >
        </div>
        }} @case (itemOrQuantityDiscrepancies.WRONG_SMN_SHIPPED) {
        <sag-ui-radio-group
            label="Can you identify the carton ID# for the box/pallet the product was received in?"
            direction="row"
            [required]="true"
        >
            <sag-ui-radio name="canIdentifyCartonId" formControlName="canIdentifyCartonId" [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio name="canIdentifyCartonId" formControlName="canIdentifyCartonId" [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>
        @if (itemOrQuantityInternationalForm?.get('canIdentifyCartonId')?.value) {
        <sag-ui-input
            [required]="true"
            label="Carton / Pallet ID#"
            placeholder="3280823429"
            formControlName="cartonId"
            class="max-w-input"
        ></sag-ui-input>
        }} @default {
        <sag-ui-radio-group
            label="Can you identify the carton ID# for the box/pallet the product was received in?"
            direction="row"
            [required]="true"
        >
            <sag-ui-radio name="canIdentifyCartonId" formControlName="canIdentifyCartonId" [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio name="canIdentifyCartonId" formControlName="canIdentifyCartonId" [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>
        @if (itemOrQuantityInternationalForm?.get('canIdentifyCartonId')?.value) {
        <sag-ui-input
            [required]="true"
            label="Carton / Pallet ID#"
            placeholder="3280823429"
            formControlName="cartonId"
            class="max-w-input"
        ></sag-ui-input>
        } } } @if (showFinancialAdjustment) {
        <sag-ui-select
            [required]="true"
            label="Financial Adjustment Request?"
            placeholder=""
            formControlName="financialAdjustment"
            class="max-w-input"
        >
            @for (financialAdjustment of financialAdjustments() | keyvalue; track $index) {
            <sag-ui-option [value]="financialAdjustment.value">{{ financialAdjustment.value }}</sag-ui-option>
            }
        </sag-ui-select>
        } @if(showRelatedDocuments) {
        <app-attachments-input [form]="itemOrQuantityInternationalForm!" controlName="relatedDocuments" />
        }
        <sag-ui-textarea
            [required]="true"
            label="Provide any additional information that will aid the Root Cause Investigation"
            placeholder="Provide any relevant details about the issue"
            formControlName="additionalInfo"
            class="max-w-input"
        />
        <div class="flex justify-end max-w-input">
            <sag-ui-button [disabled]="!isValid()" (click)="handleConfirm()" size="sm">Confirm</sag-ui-button>
        </div>
    </div>
</section>
